// src/components/CallToAction.js
import React from "react";
import { Link } from "react-router-dom";

const CallToAction = ({ 
  countryName, 
  directoryUrl, 
  buttonText 
}) => {
  // 1. Strict contextual safety overrides
  const targetCountry = countryName || "Global Ecosystems";
  const targetUrl = directoryUrl || "/browse-investors";
  const finalButtonText = buttonText || `View ${targetCountry} Directory →`;

  return (
    <div className="group my-8 p-6 bg-gradient-to-br from-blue-50/50 via-indigo-50/20 to-white border border-blue-100/70 rounded-2xl shadow-sm hover:shadow-md hover:border-blue-200/80 transition-all duration-300 flex flex-col lg:flex-row items-center justify-between gap-6 relative overflow-hidden">
      
      {/* Subtle decorative background canvas accents */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-blue-100/20 rounded-full blur-2xl pointer-events-none transform translate-x-8 -translate-y-8" />
      
      <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4 flex-1">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-blue-50 text-blue-600 text-2xl shrink-0 transform group-hover:scale-110 group-hover:rotate-12 transition-transform duration-300 select-none">
          <span role="img" aria-label="Rocket launch accelerator graphic">🚀</span>
        </div>
        
        <div className="flex-1">
          <h3 className="text-xl font-bold text-gray-900 tracking-tight">
            Ready to pitch verified capital allocators in {targetCountry}?
          </h3>
          <p className="text-sm font-medium text-gray-500 mt-1 max-w-2xl leading-relaxed">
            Skip unresponsive cold outbound channels. Connect directly with active angel networks, venture capital firms, and institutional syndicates pre-vetted securely by InvestorLanes.
          </p>
        </div>
      </div>

      {/* Optimized interactive navigation link element block */}
      <Link
        to={targetUrl}
        className="w-full lg:w-auto text-center bg-gray-900 text-white hover:bg-blue-600 font-bold px-6 py-3 rounded-xl shadow-sm hover:shadow-lg hover:shadow-blue-500/10 transition-all duration-200 whitespace-normal sm:whitespace-nowrap transform active:scale-98"
      >
        {finalButtonText}
      </Link>
    </div>
  );
};

export default CallToAction;
